var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"button is-link feedback-link",attrs:{"to":{ name: 'contact' }}},[_vm._v(" Feedback ")])}
var staticRenderFns = []

export { render, staticRenderFns }